/** Línea de vida: eje de edades de hoy al horizonte, marcas por objetivo (etiquetas alternadas) y fases como franjas. */
export function LineaTiempo({ desde, hasta, hoy, marcas, franjas = [] }: {
  desde: number; hasta: number; hoy: number; marcas: { x: number; etiqueta: string }[]; franjas?: { desde: number; hasta: number; etiqueta: string }[];
}) {
  const span = Math.max(1, hasta - desde);
  const pos = (v: number) => `${Math.max(0, Math.min(1, (v - desde) / span)) * 100}%`;
  const ordenadas = [...marcas].sort((a, b) => a.x - b.x);
  return (
    <div className="relative px-2 pb-2 pt-12">
      {franjas.map((f, i) => (
        <div key={i} className="absolute top-[3.1rem] h-3 rounded-sm text-[10px]" style={{ left: pos(f.desde), width: `calc(${pos(f.hasta)} - ${pos(f.desde)})`, background: i % 2 ? "rgba(61,65,82,.06)" : "rgba(61,65,82,.11)" }} title={f.etiqueta} />
      ))}
      <div className="relative h-3">
        <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2" style={{ background: "var(--viz-eje)" }} />
        <div className="absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full ring-2 ring-white" style={{ left: pos(hoy), background: "var(--viz-serie)" }} title={`Hoy: ${hoy}`} />
        {ordenadas.map((m, i) => (
          <div key={i} className="absolute top-1/2 -translate-x-1/2" style={{ left: pos(m.x) }}>
            <div className="h-3 w-0.5 -translate-y-1/2 rounded" style={{ background: "var(--viz-objetivo)" }} />
            <div className={`absolute left-1/2 w-24 -translate-x-1/2 text-center text-[11px] leading-tight text-tinta ${i % 2 ? "top-4" : "bottom-5"}`}>
              <span className="tabular font-semibold">{m.x}</span> <span className="text-tinta-suave">{m.etiqueta}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-10 flex justify-between text-[11px] text-tinta-suave"><span>Hoy · {hoy}</span><span>{hasta}</span></div>
    </div>
  );
}
